import { useMutation } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import useAlerts from './useAlerts';

const { addAlert } = useAlerts();

const ADD_COMPANY_MUTATION = gql`
  mutation AddCompanyMutation($company: TBL_COMPANY_Input) {
    addCompany(company: $company)
  }
`;

const UPDATE_COMPANY_MUTATION = gql`
  mutation UpdateCompanyMutation($companyid: ID!, $company: TBL_COMPANY_Input) {
    updateCompany(COMPANYID: $companyid, company: $company)
  }
`;

const DELETE_COMPANY_MUTATION = gql`
  mutation DeleteCompanyMutation($companyid: ID!) {
    deleteCompany(COMPANYID: $companyid)
  }
`;

export default function useCompanyMutate() {
  const { mutate: addMutate } = useMutation(ADD_COMPANY_MUTATION);
  const { mutate: updateMutate } = useMutation(UPDATE_COMPANY_MUTATION);
  const { mutate: deleteMutate } = useMutation(DELETE_COMPANY_MUTATION);

  async function addCompany(company) {
    try {
      const { data } = await addMutate({ company });
      return data;
    } catch (error) {
      console.error('Error adding new company:', error);
      addAlert('Error adding new company', 'high', 4);
      throw error;
    }
  }

  async function updateCompany(companyid, company) {
    try {
      const { data } = await updateMutate({ companyid, company });
      return data;
    } catch (error) {
      console.error('Error updating company:', error);
      addAlert('Error updating company', 'high', 4);
      throw error;
    }
  }

  async function deleteCompany(companyid) {
    try {
      const { data } = await deleteMutate({ companyid });
      return data;
    } catch (error) {
      console.error('Error deleting company:', error);
      addAlert('Error deleting company', 'high', 4);
      throw error;
    }
  }

  return {
    addCompany,
    updateCompany,
    deleteCompany,
  };
}
